import React, { useState } from "react";
import { Button, CircularProgress, Dialog } from "@mui/material";
import styles from "./Tasks.module.css";
import { useSelector } from "react-redux";
import DeleteIcon from "../../../../../assets/images/blinkingDeleteIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import Remainder from "../../../../assets/images/RemainderIconForSendingMails.svg";

function RemainderPopup(props: any) {
  const {
    handlePopupYesButton,
    handlePopupNoButton,
    loading,
    isOpen,
    setIsOpen,
    textForReminder,
  } = props;
  return (
    <Dialog
      open={isOpen}
      sx={{
        zIndex: "9999999",
        minWidth: "414px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "500px",
          maxHeight: "250px",
          minHeight: "155px",
          padding: "34px",
          borderRadius: "8px",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
          // left: "10%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div className={styles.deactivationPopup}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            // gap: "20px",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              cursor: "pointer",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <CloseIcon
              onClick={() => {
                setIsOpen(false);
              }}
              style={{
                pointerEvents: loading ? "none" : "auto",
                opacity: loading ? 0.5 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "10px",
              gap: "10px",
            }}
          >
            <div>
              <img src={Remainder} />
            </div>
            <div>
              <div className={styles.popupHead}>Enable Remainder</div>
              <div className={styles.popupSubHead}>
                {"Do you want to send bulk reminders for the tasks?"}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.popupButtonDiv}>
          <Button
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#ffffff",
              color: "#344054",
              border: "1px solid #D0D5DD",
            }}
            onClick={() => {
              handlePopupNoButton();
              setIsOpen(false);
            }}
            fullWidth
            disabled={loading}
          >
            No
          </Button>
          <Button
            sx={{
              textTransform: "capitalize",
              backgroundColor: "rgba(17, 200, 155, 1)",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "rgba(17, 200, 155, 1)",
              },
            }}
            onClick={() => {
              handlePopupYesButton();
              // setIsOpen(false);
            }}
            fullWidth
            disabled={loading}
          >
            {/* Yes */}
            {loading ? <CircularProgress size={18} color={"inherit"} /> : "Yes"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default RemainderPopup;
